<template>
  <section id="exams" class="py-16 bg-gray-50">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-12">
        <h2 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-dark">证书考试</h2>
        <p class="mt-4 text-gray-medium max-w-2xl mx-auto">各类职业技能证书考试信息，助您规划职业发展路径</p>
      </div>

      <!-- 错误提示 -->
      <div v-if="error" class="text-center py-6 mb-8">
        <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4 max-w-md mx-auto">
          <div class="flex items-center justify-center mb-2">
            <i class="fas fa-exclamation-triangle text-yellow-500 text-lg mr-2"></i>
            <h3 class="text-sm font-semibold text-yellow-800">离线模式</h3>
          </div>
          <p class="text-yellow-700 text-xs">{{ error }}</p>
        </div>
      </div>

      <!-- 考试列表 -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 lg:gap-6">
        <div 
          v-for="exam in exams" 
          :key="exam.id"
          class="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow"
        >
          <div class="p-6">
            <div class="flex items-start justify-between mb-4 gap-3">
              <h3 class="text-xl font-semibold flex-1 min-w-0">{{ exam.name }}</h3>
              <span :class="[
                'px-2 py-1 text-xs rounded-full whitespace-nowrap flex-shrink-0',
                exam.status === 'open' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600'
              ]">
                {{ exam.status === 'open' ? '报名中' : '已截止' }}
              </span>
            </div>
            
            <p class="text-gray-600 mb-4">{{ exam.description || '面向专业人员，考核相关领域核心技能' }}</p>
            
            <div class="space-y-2 text-sm text-gray-500 mb-4">
              <div class="flex items-center">
                <i class="fas fa-calendar mr-2"></i>
                <span>考试时间：{{ exam.exam_date }}</span>
              </div>
              <div class="flex items-center">
                <i class="fas fa-clock mr-2"></i>
                <span>报名截止：{{ exam.registration_deadline }}</span>
              </div>
              <div class="flex items-center">
                <i class="fas fa-map-marker-alt mr-2"></i>
                <span>考试地点：{{ exam.location || '全国各地' }}</span>
              </div>
              <div class="flex items-center">
                <i class="fas fa-money-bill mr-2"></i>
                <span>考试费用：¥{{ exam.price || exam.fee }}</span>
              </div>
            </div>

            <div class="space-y-3">
              <div class="flex items-center gap-2">
                <button 
                  class="flex-1 px-3 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors whitespace-nowrap text-sm font-medium"
                  @click="goToCourses(exam)"
                >
                  课程学习
                </button>
                <!-- <button 
                  class="flex-1 px-3 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors whitespace-nowrap text-sm font-medium"
                  @click="registerExam(exam)"
                >
                  立即报名
                </button> -->
              </div>
              <div class="flex items-center justify-between">
                <span class="text-sm text-gray-500 flex-shrink-0">{{ exam.participants }}人已报名</span>
                <button 
                  class="px-3 py-1.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap text-sm"
                  @click="viewExamDetail(exam.id)"
                >
                  查看详情
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 查看更多 -->
      <div class="mt-10 text-center">
        <button 
          @click="$router.push('/exams')"
          class="px-6 py-3 bg-white border border-gray-light rounded-lg text-gray-dark font-medium hover:bg-light transition-custom flex items-center mx-auto"
        >
          <span>查看更多考试</span>
          <i class="fas fa-arrow-right ml-2"></i>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { examAPI } from '@/api/services'

export default {
  name: 'ExamsSection',
  data() {
    return {
      exams: [],
      error: null
    }
  },
  async mounted() {
    await this.loadExams()
  },
  methods: {
    async loadExams() {
      this.error = null
      
      try {
        const response = await examAPI.getExams({ 
          page: 1, 
          limit: 8 
        })
        this.exams = response.data || response
      } catch (error) {
        console.error('加载考试列表失败:', error)
        this.error = error.msg || error.message || '服务器连接失败，无法加载考试数据'
        this.exams = []
      }
    },
    
    goToCourses(exam) {
      // 检查用户是否已登录
      if (!this.$store.getters.isLoggedIn) {
        this.$message.warning('请先登录后再进行课程学习')
        this.$store.commit('SHOW_LOGIN_MODAL')
        return
      }
      
      // 判断考试是否有关联的课程ID
      if (exam && exam.course_id) {
        // 如果有课程ID，跳转到该课程的详情页面
        this.$router.push(`/course/${exam.course_id}`)
      } else {
        // 如果没有课程ID，跳转到课程列表页面
        this.$router.push('/courses')
      }
    },
    
    registerExam(exam) {
      // 检查考试状态
      if (exam.status !== 'open') {
        this.$message.warning('该考试报名已截止')
        return
      }
      // 跳转到报名页面，并通过路由参数传递考试ID和名称
      this.$router.push({
        path: '/tcm-registration',
        query: { 
          examId: exam.id,
          examName: exam.name
        }
      })
    },
    
    viewExamDetail(examId) {
      this.$router.push(`/exam/${examId}`)
    }
  }
}
</script>

<style lang="less" scoped>
.transition-custom {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
</style> 